/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Snap_To_Event_StartInputs */



/**
* | output |
* | --- |
* | "Snap to Event Start" |
*
* @param {Snap_To_Event_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const snap_to_event_start = /** @type {((inputs?: Snap_To_Event_StartInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Snap_To_Event_StartInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aligner sur le début de l'événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("An Ereignisstart anheften")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggancia all'inizio dell'evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Перейти к началу мероприятия")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar al inicio del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("快照到事件开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント開始にスナップ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट शुरू होने पर क्लिक करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ir para o início do evento")
	return /** @type {LocalizedString} */ ("Snap to Event Start")
});